module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/100-pakistan-ab6370ea6f629c5d43d28e5a4e6ca68c.svg";